module.exports = __webpack_public_path__ + "img/product_45.5251be3.webp";